import { styled } from "@obby/components";

export const Box = styled("div", {
  variants: {
    variant: {
      banner: {
        width: "100%",
        display: "flex",
        flexWrap: "wrap",
        "@media all and (max-width: 575px)": {
          marginTop: "0 !important",
          marginBottom: "0 !important"
        },
        "@lg": {
          flexWrap: "nowrap"
        }
      },
      wrapper: {
        position: "relative"
      },
      bfDiscountBadge: {
        textAlign: "left",
        right: "1.35rem",
        top: "-5rem"
      },
      text: {
        alignItems: "center",
        padding: "6rem 1.5rem 2rem",
        // padding: "10rem 2.5rem 4rem",
        width: "100%",

        "@lg": {
          width: "50%",
          padding: "12.rem 2.5rem 5rem"
        }
      },
      imageWrap: {
        padding: "0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        width: "100%",

        "@lg": {
          width: "50%",
          maxHeight: "none"
        }
      }
    },
    reverse: {
      true: {
        flexDirection: "row-reverse"
      }
    },
    border: {
      true: {
        borderRadius: "$standard"
      }
    },
    imageWrapFull: {
      true: {
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "cover"
      }
    }
  }
});

export const ImageTag = styled("img", {
  variants: {
    variant: {
      image: {
        width: "100%",
        float: "left"
      }
    },
    typeOfBanner: {
      smallBannerImage: {
        width: "100%",
        "@sm": {}
      },
      giftCardBannerImage: {
        width: "100%",
        "@sm": {
          maxWidth: "32.5rem",
          transform: "rotate(10deg)",
          margin: "9.4rem 0",

          "@smd": {
            margin: "0"
          }
        }
      }
    }
  }
});
